import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=3f62aec2"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=3f62aec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports